import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 分页查询项目异议列表
export function getPurchaserObjectionsListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/objections/page',
    method: 'get',
    params
  })
}

// 采购人回复异议
export function setPurchaserObjectionsAskApi(data) {
  const { objectionId, ...other } = data
  return request({
    url: baseUrl + `/workbench/purchaser/objections/${objectionId}/questions/ask`,
    method: 'post',
    data: other
  })
}

// 查询异议详情
export function getPurchaserObjectionsDetailApi(objectionId) {
  return request({
    url: baseUrl + `/workbench/purchaser/objections/${objectionId}/detail`,
    method: 'get'
  })
}
